import KanbanWrapper from "./KanbanWrapper";

export default KanbanWrapper;



// WEBPACK FOOTER //
// ./src/components/Kanban/KanbanWrapper/index.js